import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { startScan } from "../lib/api";

export default function UrlScanner({
  size = "lg",
  value,
  onChange,
}) {
  const isControlled = value !== undefined && typeof onChange === "function";
  const [internalUrl, setInternalUrl] = useState("");
  const url = isControlled ? value : internalUrl;
  const setUrl = isControlled ? onChange : setInternalUrl;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!url.trim()) {
      toast.error("Enter a website URL");
      return;
    }
    setLoading(true);
    try {
      const data = await startScan(url.trim());
      toast.success("Scan started", {
        description: `Analyzing ${data.domain}…`,
      });
      navigate(`/scan/${data.scan_id}`);
    } catch (err) {
      const msg = err?.response?.data?.detail || "Could not start scan";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const isLg = size === "lg";

  return (
    <form
      onSubmit={submit}
      className={`bg-white border border-black pl-hard-shadow w-full flex items-stretch ${
        isLg ? "h-16 md:h-20" : "h-14"
      }`}
      data-testid="url-scanner-form"
    >
      <div className={`flex items-center pl-4 md:pl-5 ${isLg ? "md:pl-6" : ""}`}>
        <Search className={`text-[#0047FF] ${isLg ? "w-6 h-6" : "w-5 h-5"}`} strokeWidth={2.4} />
      </div>
      <input
        type="text"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        placeholder="yourwebsite.com"
        className={`flex-1 px-4 outline-none bg-transparent placeholder:text-[#94A3B8] ${
          isLg ? "text-lg md:text-2xl font-medium" : "text-base"
        }`}
        autoComplete="off"
        spellCheck={false}
        data-testid="url-scanner-input"
      />
      <button
        type="submit"
        disabled={loading}
        className={`pl-btn-primary px-6 md:px-8 font-display tracking-tight flex items-center gap-2 disabled:opacity-70 ${
          isLg ? "text-base md:text-lg" : "text-sm"
        }`}
        data-testid="url-scanner-submit"
      >
        {loading ? (
          <>
            <Loader2 className="w-5 h-5 animate-spin" />
            <span className="hidden sm:inline">Starting…</span>
          </>
        ) : (
          <>
            <span>Scan</span>
            <span className="hidden md:inline opacity-80">— it's free</span>
          </>
        )}
      </button>
    </form>
  );
}
